import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SafeUrl } from '@angular/platform-browser';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subscriber } from 'rxjs';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-old-student-sigph-upload-popup',
  templateUrl: './old-student-sigph-upload-popup.component.html',
  styleUrls: ['./old-student-sigph-upload-popup.component.scss']
})
export class OldStudentSigphUploadPopupComponent implements OnInit {
  photoSignDetailsForm: FormGroup;
  croppedImage: SafeUrl = '';
  submitButton = true;
  updateButton = false;
  photoExt: string;
  Photo: any;
  Sign: any;
  singExt: string;

  readonly PHOTO_MIN_WIDTH = 200;
  readonly PHOTO_MIN_HEIGHT = 230;
  readonly PHOTO_MAX_WIDTH = 500;
  readonly PHOTO_MAX_HEIGHT = 530;
  readonly PHOTO_MAX_SIZE_KB = 50; // 50KB max for photo

  readonly SIGNATURE_MIN_WIDTH = 140;
  readonly SIGNATURE_MIN_HEIGHT = 60;
  readonly SIGNATURE_MAX_WIDTH = 300;
  readonly SIGNATURE_MAX_HEIGHT = 300;
  readonly SIGNATURE_MAX_SIZE_KB = 20; // 20KB max for signature

  constructor(
    private fb: FormBuilder,
    private dialogRef2: MatDialogRef<OldStudentSigphUploadPopupComponent>,
    private modalPopupService: ModalpopService,
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
  studentId = sessionStorage.getItem('StudentRGID');

  imageChangedEvent: Event | null = null;
  dialogRef: MatDialogRef<any>;
  userImage: any;
  errormessage: string;
  signatureImage: any;
  userSign: string;
  fileName: string;
  uploadDoc: any;
  proId: any;
  disabled = false;
  tabs: string;
  displayName: any;
  Course: any;
  College: any;
  isSaving: boolean = false;

  photoActualWidth: number = 0;
  photoActualHeight: number = 0;
  signatureActualWidth: number = 0;
  signatureActualHeight: number = 0;

  ngOnInit(): void {
    console.log("thisssssssss", this.data.key);

    this.StudentPersonalId = this.data.selected.StuId;
    if (this.data.selected.Photo) {
      this.Photo = this.data.selected.Photo;
    }
    if (this.data.selected.Sign) {
      this.Sign = this.data.selected.Sign;
    }


    this.photoSignDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentPersonalId),
      StuRgNo: new FormControl(this.studentId),
      StuPhoto: new FormControl('', Validators.required),
      StuSignature: new FormControl('', Validators.required),
      StuABCId2: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
    });
    this.getABCId();
  }

  fileChangeEvent(event: Event): void {
    this.imageChangedEvent = event;
  }


  validateImageDimensions(file: File, type: 'photo' | 'signature'): Promise<{ isValid: boolean; width: number; height: number; message?: string }> {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const minWidth = type === 'photo' ? this.PHOTO_MIN_WIDTH : this.SIGNATURE_MIN_WIDTH;
        const minHeight = type === 'photo' ? this.PHOTO_MIN_HEIGHT : this.SIGNATURE_MIN_HEIGHT;
        const maxWidth = type === 'photo' ? this.PHOTO_MAX_WIDTH : this.SIGNATURE_MAX_WIDTH;
        const maxHeight = type === 'photo' ? this.PHOTO_MAX_HEIGHT : this.SIGNATURE_MAX_HEIGHT;
        const maxSizeKB = type === 'photo' ? this.PHOTO_MAX_SIZE_KB : this.SIGNATURE_MAX_SIZE_KB;
        const fileSizeKB = file.size / 1024;


        if (type === 'photo') {
          this.photoActualWidth = img.width;
          this.photoActualHeight = img.height;
        } else {
          this.signatureActualWidth = img.width;
          this.signatureActualHeight = img.height;
        }


        if (fileSizeKB > maxSizeKB) {
          resolve({
            isValid: false,
            width: img.width,
            height: img.height,
            message: `File size exceeds limit. Maximum allowed: ${maxSizeKB}KB. Your file: ${fileSizeKB.toFixed(2)}KB.`
          });
          URL.revokeObjectURL(img.src);
          return;
        }

        const widthInRange = img.width >= minWidth && img.width <= maxWidth;
        const heightInRange = img.height >= minHeight && img.height <= maxHeight;

        const isWidthValid = widthInRange && img.height >= minHeight;
        const isHeightValid = heightInRange && img.width >= minWidth;

        let isValid = false;
        let message = '';

        if (isWidthValid || isHeightValid) {
          isValid = true;


          if (img.width === minWidth && img.height === minHeight) {
            message = `Image uploaded successfully`;
          } else if (img.width === maxWidth && img.height === maxHeight) {
            message = `Image uploaded successfully`;
          } else if (img.width === minWidth || img.width === maxWidth) {
            message = `Image uploaded successfully`;
          } else if (img.height === minHeight || img.height === maxHeight) {
            message = ` Image uploaded successfully`;
          } else if (widthInRange && heightInRange) {
            message = `Image uploaded successfully`;
          } else if (isWidthValid) {
            message = `Image uploaded successfully `;
          } else if (isHeightValid) {
            message = ` Image uploaded successfully `;
          }
        } else {
          isValid = false;


          if (img.width < minWidth) {
            message = `Width is too small. Minimum required: ${minWidth}px.`;
          } else if (img.width > maxWidth) {
            message = `Width is too large. Maximum allowed: ${maxWidth}px.`;
          } else if (img.height < minHeight) {
            message = `Height is too small. Minimum required: ${minHeight}px.`;
          } else if (img.height > maxHeight) {
            message = `Height is too large. Maximum allowed: ${maxHeight}px.`;
          }
        }

        resolve({
          isValid,
          width: img.width,
          height: img.height,
          message
        });

        URL.revokeObjectURL(img.src);
      };
      img.onerror = () => {
        resolve({ isValid: false, width: 0, height: 0, message: 'Failed to load image' });
        URL.revokeObjectURL(img.src);
      };
      img.src = URL.createObjectURL(file);
    });
  }

  private showErrorDialog(message: string): void {
    const data = {
      message: message,
      title: 'Information',
      icon: 'fas fa-close'
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe(() => { });
  }

  private showInfoDialog(message: string): void {
    const data = {
      message: message,
      title: 'Information',
      icon: 'fas fa-info-circle'
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  }

  onChange1($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    if (!file) return;

    const fileName = file.name;
    this.fileName = fileName;
    this.photoExt = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
    if (!['jpg', 'jpeg'].includes(this.photoExt)) {
      this.showErrorDialog('File not supported. Please upload JPG or JPEG image only for photo.');
      return;
    }
    this.photoActualWidth = 0;
    this.photoActualHeight = 0;
    this.validateImageDimensions(file, 'photo').then(({ isValid, width, height, message }) => {
      if (!isValid) {
        this.showErrorDialog(message);
        return;
      }

      if (message) {
        this.showInfoDialog(message);
      }

      this.convertToBase641(file);
    });
  }

  onChangeSign($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    if (!file) return;

    const fileName = file.name;
    this.fileName = fileName;
    this.singExt = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
    if (!['jpg', 'jpeg'].includes(this.singExt)) {
      this.showErrorDialog('File not supported. Please upload JPG or JPEG image only for signature.');
      return;
    }
    this.signatureActualWidth = 0;
    this.signatureActualHeight = 0;
    this.validateImageDimensions(file, 'signature').then(({ isValid, width, height, message }) => {
      if (!isValid) {
        this.showErrorDialog(message);
        return;
      }

      if (message) {
        this.showInfoDialog(message);
      }

      this.convertToBase64Sign(file);
    });
  }

  convertToBase641(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile1(file, subscriber);
    });

    observable.subscribe((base64Data: string) => {
      this.userImage = base64Data;
      this.photoSignDetailsForm.get('StuPhoto')?.setValue(base64Data);

      if (!this.userImage) {
        this.photoSignDetailsForm.get('StuPhoto')?.markAsTouched();
      } else {
        this.photoSignDetailsForm.get('StuPhoto')?.markAsUntouched();
      }
    });
  }

  readFile1(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  convertToBase64Sign(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFileSign(file, subscriber);
    });

    observable.subscribe((base64Data: string) => {
      this.signatureImage = base64Data;
      this.photoSignDetailsForm.get('StuSignature')?.setValue(base64Data);

      if (!this.signatureImage) {
        this.photoSignDetailsForm.get('StuSignature')?.markAsTouched();
      } else {
        this.photoSignDetailsForm.get('StuSignature')?.markAsUntouched();
      }
    });
  }

  readFileSign(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  prepopulation() {
    if (this.data.key == 'view' && this.data.key === 'view') {
      this.updateButton = false;
    } else {
      this.updateButton = true;
    }
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    // this.umsService.fetchPhotoSignDetails(payload).subscribe((res) => {
    //   const data = res.data[0];
    //   this.proId = res.data[0].StuProfId;
    //   this.spinner.hide();
    //   if (res.status) {
    //     if ((res.data[0].StuPhoto && res.data[0].StuPhoto.startsWith('data:')) || res.data[0].StuPhoto == null || res.data[0].StuSignature == null) {
    //       this.userImage = res.data[0].StuPhoto;
    //       this.signatureImage = res.data[0].StuSignature;

    //       this.photoSignDetailsForm.patchValue({
    //         StuPhoto: new FormControl(this.userImage, Validators.required),
    //         StuSignature: new FormControl(this.signatureImage, Validators.required),
    //       });
    //     } else {
    //       this.getFiles(res.data);
    //     }
    //   }
    // })

    let data = {}
    this.getFiles(data);
  }

  getFiles(data) {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    payload['fileNames'] = [
      this.Photo ?? '',
      this.Sign ?? ''
    ];
    this.umsService.getFilesDetails(payload).subscribe((res) => {
      this.spinner.hide();
      const files = res.files || [];
      const photoFile = files.find((f: any) =>
        f.fileName?.toLowerCase().includes('photo') || f.fileName?.toLowerCase().includes('stu')
      );
      const signFile = files.find((f: any) =>
        f.fileName?.toLowerCase().includes('sign') || f.fileName?.toLowerCase().includes('signature')
      );

      this.userImage = photoFile?.base64Data || '';
      this.signatureImage = signFile?.base64Data || '';
      this.photoSignDetailsForm.patchValue({
        StuPhoto: new FormControl(this.userImage, Validators.required),
        StuSignature: new FormControl(this.signatureImage, Validators.required),
      });
    });
  }

  updateCheck() {
    if (this.photoSignDetailsForm.invalid) {
      this.photoSignDetailsForm.markAllAsTouched();
      return;
    }

    if (!this.userImage || !this.signatureImage) {
      if (!this.userImage) {
        this.photoSignDetailsForm.get('StuPhoto')?.markAsTouched();
      }
      if (!this.signatureImage) {
        this.photoSignDetailsForm.get('StuSignature')?.markAsTouched();
      }
      return;
    }

    this.UpdatePhotoSign();
    this.saveFiles();
    this.updateAdditionalDetails();
  }

  UpdatePhotoSign() {
    this.spinner.show();
    let payload = this.photoSignDetailsForm.value;
    payload.StuId = parseInt(payload.StuId);
    payload.StuRgNo = parseInt(payload.StuRgNo);
    payload.StuPhoto = "photo." + this.photoExt;
    payload.StuSignature = "sign." + this.singExt;
    payload['StuProfId'] = this.proId;
    payload.LoginId = parseInt(sessionStorage.getItem('StudentRGID'));
    // this.umsService.updatePhotoSignDetails(payload).subscribe(res => {
    //   if (res.status) {
    //     this.spinner.hide();
    //     let data = {}
    //     data['message'] = res.message;
    //     data['title'] = 'Information';
    //     data['icon'] = 'fas fa-check';
    //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //     this.dialogRef.afterClosed().subscribe((result) => {
    //       this.dialogRef2.close();
    //     });
    //   }
    // });
  }

  submitCheck() {
    if ((this.userImage == '' && this.signatureImage == '') || (this.userImage == null && this.signatureImage == null)) {
      this.photoSignDetailsForm.get('StuSignature')?.markAsTouched();
      this.photoSignDetailsForm.get('StuPhoto')?.markAsTouched();
    }
    else if ((this.userImage == null || this.userImage == '') && (this.signatureImage != null || this.signatureImage != '')) {
      this.photoSignDetailsForm.get('StuPhoto')?.markAsTouched();
    }
    else if ((this.userImage != null || this.userImage != '') && (this.signatureImage == null || this.signatureImage == '')) {
      this.photoSignDetailsForm.get('StuSignature')?.markAsTouched();
    }
    else {
      this.save();
      this.saveFiles();
    }
  }

  save() {
    this.isSaving = true;
    this.submitButton = true;
    this.updateButton = false;
    const payload = this.photoSignDetailsForm.value;
    payload.StuId = parseInt(payload.StuId);
    payload.StuRgNo = parseInt(payload.StuRgNo);
    payload.StuPhoto = "photo." + this.photoExt;
    payload.StuSignature = "sign." + this.singExt;
    payload.LoginId = parseInt(sessionStorage.getItem('StudentRGID'));
    // this.umsService.addPhotoSignDetails(payload).subscribe(res => {
    //   if (res.status) {
    //     this.isSaving = false;
    //     this.spinner.hide();
    //     let data = {}
    //     data['message'] = res.message;
    //     data['title'] = 'Information';
    //     data['icon'] = 'fas fa-check';
    //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //   }
    //   else {
    //     this.isSaving = false;
    //     this.spinner.hide();
    //   }
    // }, (ERROR: HttpErrorResponse) => {
    //   this.isSaving = false;
    //   this.spinner.hide();
    // });
  }

  saveFiles() {
    const payload = {
      StuId: parseInt(this.photoSignDetailsForm.value.StuId),
      StuRgNo: this.data.selected.StuRgNo,
      files: [
        {
          fileName: "photo." + this.photoExt,
          base64Data: this.userImage
        },
        {
          fileName: "sign." + this.singExt,
          base64Data: this.signatureImage
        }
      ]
    };
    this.umsService.saveFilesDetails(payload).subscribe(
      res => {
        if (res.status) {
          this.spinner.hide();
        } else {
          this.isSaving = false;
          this.spinner.hide();
        }
      },
      (error: HttpErrorResponse) => {
        this.isSaving = false;
        this.spinner.hide();
      }
    );
  }

  updateAdditionalDetails() {
    let payload = {}
    payload['StuId'] = parseInt(this.photoSignDetailsForm.value.StuId);
    payload['ABCId'] = this.photoSignDetailsForm.value.StuABCId2;
    payload['StuRgNo'] = this.data.selected.StuRgNo;
    payload['isOldStudent'] = true;
    payload['Photo'] = 'photo.' + this.photoExt;
    payload['Sign'] = 'sign.' + this.singExt;
    this.Photo = 'photo.' + this.photoExt;
    this.Sign = 'sign.' + this.singExt;

    this.umsService.updateABCId(payload).subscribe(res => {
      this.spinner.hide();

      if (res.status) {
        let data = {}
        data['message'] = "Details updated successfully!";
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

        this.dialogRef.afterClosed().subscribe(() => {
          this.dialogRef2.close();
        });
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getABCId() {
    let payload = {};
    payload['StuId'] = parseInt(this.photoSignDetailsForm.value.StuId);
    payload['CgCode'] = ''
    payload['CoCode'] = ''
    payload['StuRgNo'] = this.data.selected.StuRgNo;
    this.umsService.oldtudentData(payload).subscribe(async (res) => {
      if (res.status) {
        this.photoSignDetailsForm.get('StuABCId2')?.setValue(res.data[0].StuABCId);
        if (res.data[0].Photo) {
          this.Photo = res.data[0].Photo;
        }
        if (res.data[0].Sign) {
          this.Sign = res.data[0].Sign;
        }

      }
      else {
        this.photoSignDetailsForm.get('StuABCId2')?.setValue('')
      }
      this.prepopulation();
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }
}